<div class='VsmControl'>
  <app-select
    (selection)='onVsmSelect($event)'
    *ngIf="column.account_role !== 'vsm' && column.account_role !== 'master' && column.account_role !== 'franchisee'"
    [defaultValue]='column.vsm_group_id || null'
    [items]='getVsms()'
    [label]="'Select Edge Group'"></app-select>
  <a (click)='openDialog()' *ngIf="column.account_role === 'vsm' && false"
  >Edge Account</a
  >
  <mat-icon (click)='resetVsm()' *ngIf='column.vsm_group_id'>close</mat-icon>
</div>
